import createModel from "../createModel";
import { CodeValueLegacy } from "../common/CodeValueLegacy";

export const MutualFundsProfileChange = createModel("MutualFundsProfileChange", (json) => ({
    effectiveDate: json.EffectiveDate,
    targetProfile: CodeValueLegacy.fromServer(json.TargetProfile),
}));
